import { abortIfNotPermitted } from '../../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "stock-check" */ '@js/franchise_component/franchise-inventory/stock-check/stock-check-index.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_stock_check',
                next,
            );
        },
    },
    {
        path: '/create',
        component: () =>
            import(/* webpackChunkName: "stock-check-create" */ '@js/franchise_component/franchise-inventory/stock-check/stock-check-create.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_inventory_stock_check',
                next,
            );
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "stock-check-create" */ '@js/franchise_component/franchise-inventory/stock-check/stock-check-edit.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_stock_check',
                next,
            );
        },
    },
];
